interface WithRetryParams<T> {
  operation: () => Promise<T>;
  attempts?: number;
  delay?: number;
  onRetryError?: (err: unknown) => void;
}

export const withRetry = async <T>({
  operation,
  attempts = 3,
  delay = 1000,
  onRetryError,
}: WithRetryParams<T>): Promise<T> => {
  let lastError: unknown;

  for (let attempt = 1; attempt <= attempts; attempt++) {
    try {
      return await operation();
    } catch (error) {
      lastError = error;
      if (attempt === attempts) throw error;
      onRetryError && onRetryError(error);
      const backoff = delay * 2 ** (attempt - 1);
      await new Promise((resolve) => setTimeout(resolve, backoff));
    }
  }

  throw lastError;
};
